//vendors
import React from 'react';
import classNames from 'classnames';
//components
import {CheckIcon} from './check_icon';
import {Tooltip} from "@acc/tooltip";
import {VBox} from "@acc/layout";
//styles
import styles from './checkbox.module.scss';

type Props = {
	name: string,
	label: string,
	onChange: (value: boolean | any) => void,
	value?: boolean,
	disabled?: boolean,
	className?: string,
	info?: string
	tooltip?: string | JSX.Element
};

export const Checkbox = (props: Props) => {
	return (
		<div className={classNames(styles.root, props.className, {[styles.isDisabledRoot]: props.disabled})}>
			<input
				id={props.name}
				type="checkbox"
				disabled={props.disabled}
				onChange={props.onChange}
				checked={props.value}
			/>
			<label htmlFor={props.name}>
        <span className={classNames(styles.fakeCheck, {[styles.isDisabled]: props.disabled})}>
          {props.value && <CheckIcon/>}
        </span>
				
				<div className={styles.titleWrap}>
					{props.tooltip
						? (
							<Tooltip
								message={<VBox className={styles.tooltipMsg}>{props.tooltip}</VBox>}
								placement="top"
								trigger="hover"
								delayShow={1000}
							>
								<span className={styles.title}>{props.label}</span>
							</Tooltip>
						)
						: <span className={styles.title}>{props.label}</span>
					}

					{!!props.info && <span className={styles.info}>{props.info}</span>}
				</div>
			</label>
		</div>
	)
}

Checkbox.defaultProps = {
	disabled: false
};
